import { useQuery } from '@tanstack/react-query';
import { fetchCurrencyTypeDropApi } from 'apis/platform/currencyApis';
import { useTranslation } from 'react-i18next';
import { IDropListProps } from 'utils/types/common';
/**
 * * 플랫폼 - 재화 - 재화 타입 드롭다운
 */

function useCurrencyTypeDropQuery() {
  const { t } = useTranslation();
  const { status, data, error, isFetching } = useQuery(
    ['currencyTypeDropList'],
    async () => await fetchCurrencyTypeDropApi(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: t(
              `currencyMaster.headerSelect.commodityTyeSelectData.${i}.text`,
            ),
            comment: v.comment,
          }),
        );
        newArr.push({
          key: newArr?.length,
          value: '',
          text: t('currencyMaster.headerSelect.noTreasureType'),
        });
        return newArr;
      },
      onSuccess: (data) => {
        // console.log(data);
      },
    },
  );
  return { status, data, error, isFetching };
}

export default useCurrencyTypeDropQuery;
